import React, { useState, useEffect, useContext } from 'react'
import { ThemeContext } from '../../../context/ThemeContext';
import { Delete } from 'lucide-react';

import CustomButton from '../../Componentization/CustomButton';
import CustomText from '../../../styles/CustomText';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { checkQssPassword, checkHeaderText } from '../../../store';
import { BounceLoader } from "react-spinners";

import useQssMnemonic from '../../../hooks/useQssMnemonic';
import useSecureStorage from '../../../hooks/useSecureStorage';

/**
 * @brief QSS 니모닉 리스트 페이지 진입 전 비밀번호 입력 스크린
 * @returns 
 */
const QssSettingMnemonicPassword: React.FC = () => {
	const { theme } = useContext(ThemeContext)
	const { t } = useTranslation();
	const navigate = useNavigate();
	let dispatch = useDispatch();
	const { chackQssPassword, getQssMnemonic, addQssMnemonic, clearQssMnemonic, removeQssMnemonic } = useQssMnemonic()
	const { getBlockChain } = useSecureStorage()

	const [pin, setPin] = useState<string[]>([])
	const [confirmPin, setConfirmPin] = useState<string[]>([])
	const [isConfirming, setIsConfirming] = useState(false)
	const [error, setError] = useState(false)
	const [modalVisible, setModalVisible] = useState(false)
	const [shuffledKeys, setShuffledKeys] = useState<string[]>([])
	const [showLoading, setShowLoading] = useState(false)

	useEffect(() => {
		dispatch(checkHeaderText({ "link": "QssLoadPassword", "title": '' }))
		setShuffledKeys(shuffleArray(['1', '2', '3', '4', '5', '6', '7', '8', '9', '0']))
	}, [])

	useEffect(() => {
		if (pin.length === 6 && !isConfirming) {
			setTimeout(() => {
				handleConfirm()
			}, 200)
		}
	}, [pin, isConfirming])


	const handleKeyPress = (key: string) => {
		if (key === 'backspace') {
			setPin(prevPin => prevPin.slice(0, -1))
		} else {
			if (pin.length < 6) {
				setPin(prevPin => [...prevPin, key])
			}
		}
	}

	const handleConfirm = async () => {
		try {
			const strPin = pin.join('')
			const selNetwork = await getBlockChain()
			const checkPin = await chackQssPassword(strPin, selNetwork)

			if (true === checkPin) {
				// qSS 비밀번호 임시 저장
				dispatch(checkQssPassword(strPin))

				// 로딩 표시
				setShowLoading(true)

				// QssSettingDataList 페이지로 이동
				setTimeout(() => {
					// @ts-ignore
					navigate(`/QssSettingDataList`, { replace: true, state: { } });
				}, 1000)

			} else {
				setError(true)
				setTimeout(() => {
					setPin([])
					setError(false)
				}, 1000)
			}
		} catch (error) {
			console.error('Failed to chackQssPassword', error)
			setError(true)
			setShowLoading(false)
			setTimeout(() => {
				setPin([])
				setError(false)
			}, 1000)
		}
	}

	const handleModalClose = async (useFingerprint: boolean) => {
		setModalVisible(false)
		navigate(`/QssSaveProcess`, { replace: true, state: { } });
	}

	const shuffleArray = (array: string[]) => {
		let currentIndex = array.length,
			randomIndex

		while (currentIndex !== 0) {
			randomIndex = Math.floor(Math.random() * currentIndex)
			currentIndex--
				;[array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]]
		}

		return array
	}

	const renderKey = (key: string, index: number) => (
		<div key={index}>
			<div
				onClick={() => { handleKeyPress(key) }}
				style={{
					// backgroundColor: theme.keyPadBackgroundColor,
					borderRadius: '50%',
				}}
			>
				<div style={styles.key}>
					<CustomText weight='medium' style={{ ...styles.keyText, color: theme.label_strong }}>
						{key}
					</CustomText>
				</div >
			</div >
		</div >
	)

	const styles = {
		header: {
			height: "135px"
		} as React.CSSProperties,
		title1: {
			fontSize: 24,
			textAlign: 'center',
			color: theme.text_01
		} as React.CSSProperties,
		title2: {
			fontSize: 24,
			textAlign: 'center',
			color: theme.text_01,
			marginBottom: 10
		} as React.CSSProperties,
		subtitle1: {
			fontSize: 14,
			color: theme.text_03,
			textAlign: 'center'
		} as React.CSSProperties,
		pinContainer: {
			display: "flex",
			justifyContent: 'center',
			alignItems: 'center',
			gap: '10px',
		} as React.CSSProperties,
		pinDot: {
			width: 12,
			height: 12,
			borderRadius: 8,
			margin: 8
		} as React.CSSProperties,
		pinDotError: {
			backgroundColor: theme.pinCode_background_03,
			borderColor: theme.border_01
		} as React.CSSProperties,
		basicText: {
			fontSize: 14,
			height: "40px",
			display: "flex",
			alignItems: "flex-start",
			justifyContent: "center",
			marginTop: "15px",
			textAlign: 'center',
			lineHeight: "22px"
		} as React.CSSProperties,
		errorText: {
			fontSize: 14,
			height: "40px",
			display: "flex",
			alignItems: "flex-start",
			justifyContent: "center",
			marginTop: "15px"
		} as React.CSSProperties,
		keypadContainer: {
			width: '100%',
		} as React.CSSProperties,
		keypadRow: {
			display: "flex",
			justifyContent: 'space-around',
			width: '100%',
			marginBottom: "5px"
		} as React.CSSProperties,
		key: {
			display: "flex",
			width: 70,
			height: 70,
			justifyContent: 'center',
			alignItems: 'center',
			cursor: "pointer"
		} as React.CSSProperties,
		keyPlaceholder: {
			width: 70,
			height: 70,
		} as React.CSSProperties,
		keyText: {
			fontSize: 24,
			color: theme.text_01
		} as React.CSSProperties,
		modalOverlay: {
			width: '100%',
			height: '100%',
			display: "flex",
			justifyContent: 'center',
			alignItems: 'center',
			backgroundColor: theme.background_alternative,
			position: 'absolute',
			top: '50%',
			left: '50%',
			transform: "translate(-50%, -50%)"
		} as React.CSSProperties,
		modalContent: {
			width: '75%',
			backgroundColor: theme.static_white,
			borderRadius: 28,
			padding: 20,
			alignItems: 'center',
			textAlign: 'center'
		} as React.CSSProperties,
		modalTitle: {
			fontSize: 18,
			marginBottom: 5,
		} as React.CSSProperties,
		modalSubtitle: {
			fontSize: 16,
			marginBottom: 10,
		} as React.CSSProperties,
		modalDescription1: {
			fontSize: 14,
			textAlign: 'center'
		} as React.CSSProperties,
		modalDescription2: {
			fontSize: 14,
			marginBottom: 20,
			textAlign: 'center'
		} as React.CSSProperties,
		modalButtons: {
			display: "flex",
			justifyContent: 'space-between',
			width: '100%'
		} as React.CSSProperties,
		modalButton: {
			padding: 10,
			margin: 5,
			backgroundColor: theme.static_white,
			height: 56,
			borderRadius: 10,
			justifyContent: "center",
			width: '50%'
		} as React.CSSProperties,
		modalButtonText: {
			fontSize: 14,
			color: theme.static_white
		} as React.CSSProperties,
		modalButtonPrimaryText: {
		} as React.CSSProperties,
		loadingcontainer: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			justifyContent: 'center',
			marginTop: "150px"
		} as React.CSSProperties,
		loadingtitle: {
			fontSize: 24,
			color: theme.text_01,
			textAlign: 'center',
			margin: "5px 0 0",
		} as React.CSSProperties,
		loadingsubTitle1: {
			fontSize: 18,
			color: theme.text_01,
			textAlign: 'center',
			margin: "5px 0 0"
		} as React.CSSProperties,
		loadingsubTitle2: {
			fontSize: 18,
			color: theme.text_01,
			textAlign: 'center',
			margin: "5px 0 0"
		} as React.CSSProperties
	}

	return (
		<div className='container' style={{ backgroundColor: theme.background_normal, padding: "60px 0px 24px" }}>
			{!showLoading && (
				<>
					<div style={styles.header}>
						<CustomText weight="medium" style={{ ...styles.title1, color: theme.label_strong }}>
							{t('qss_setting_password_screen_message_01')}
						</CustomText>
						<CustomText weight="medium" style={{ ...styles.title2, color: theme.label_strong }}>
							{t('qss_setting_password_screen_message_02')}
						</CustomText>
						<CustomText style={{ ...styles.subtitle1, color: theme.text_03 }}>
							{t('qss_setting_password_screen_message_03')}
						</CustomText>
						<CustomText style={{ ...styles.subtitle1, color: theme.text_03 }}>
							{t('qss_setting_password_screen_message_04')}
						</CustomText>
					</div>
					<div>
						<div style={styles.pinContainer}>
							{Array.from({ length: 6 }).map((_, index) => {
								const baseStyle: React.CSSProperties = {
									...styles.pinDot,
								};

								const activeStyle: React.CSSProperties =
									(isConfirming ? confirmPin.length > index : pin.length > index)
										? { backgroundColor: theme.primary_normal }
										: {};

								const errorStyle: React.CSSProperties =
									error && isConfirming && confirmPin.length > index ? styles.pinDotError : {};

								return (
									<div style={{ borderBottom: `1px solid ${error?theme.status_destrective:((false === isConfirming && pin.length > index) || (true === isConfirming && confirmPin.length > index) ?theme.primary_normal:theme.line_alternative) }` }}>
										<div key={index} style={{ ...baseStyle, ...activeStyle, ...errorStyle }} />
									</div>
								);
							})}
						</div>
						{
							error
								?
								<CustomText style={{ ...styles.errorText, color: theme.status_destrective }}>
									{t('create_wallet_message_07')}
								</CustomText>
								:
								<CustomText style={{ ...styles.basicText, color: theme.label_normal }}>
									{t('create_wallet_message_14')}<br />
									{/* {t('create_wallet_message_15')} */}
								</CustomText>
						}
					</div>
					<div style={styles.keypadContainer}>
						{Array.from({ length: 3 }).map((_, rowIndex) => (
							<div key={rowIndex} style={styles.keypadRow}>
								{shuffledKeys.slice(rowIndex * 3, rowIndex * 3 + 3).map((key, index) => renderKey(key, index))}
							</div>
						))}
						<div style={styles.keypadRow}>
							<div style={styles.keyPlaceholder}></div>
							{renderKey(shuffledKeys[9], 9)}
							<div key="backspace">
								<div
									onClick={() => { handleKeyPress('backspace') }}
									style={styles.key}
								>
									<Delete size={24} color={theme.label_strong} />
								</div>
							</div>
						</div>
					</div>
					{
						modalVisible && (
							<div style={styles.modalOverlay}>
								<div style={styles.modalContent}>
									<CustomText weight="bold" style={{ ...styles.modalTitle, color: theme.static_black }}>
										{t('create_wallet_message_08')}
									</CustomText>
									<CustomText weight="bold" style={{ ...styles.modalSubtitle, color: theme.static_black }}>
										{t('create_wallet_message_09')}
									</CustomText>
									<CustomText style={{ ...styles.modalDescription1, color: theme.label_alternative }}>
										{t('create_wallet_message_10')}
									</CustomText>
									<CustomText style={{ ...styles.modalDescription2, color: theme.label_alternative }}>
										{t('create_wallet_message_11')}
									</CustomText>
									<CustomText style={{ ...styles.modalDescription1, color: theme.status_destrective }}>
										{t('create_wallet_message_17')}
									</CustomText>
									<CustomText style={{ ...styles.modalDescription2, color: theme.status_destrective }}>
										{t('create_wallet_message_18')}
									</CustomText>
									<div style={styles.modalButtons}>
										<CustomButton
											containerStyle={{ ...styles.modalButton, backgroundColor: theme.primary_alternative }}
											textStyle={{ ...styles.modalButtonText, color: theme.static_black }}
											onPress={() => handleModalClose(false)}
											text={t('create_wallet_message_12')}
											weight="medium"
											withBackground={true}
											backgroundColor={theme.primary_alternative}
										/>
										<CustomButton
											containerStyle={{ ...styles.modalButton, backgroundColor: theme.primary_normal }}
											textStyle={{ ...styles.modalButtonText, ...styles.modalButtonPrimaryText }}
											onPress={() => handleModalClose(true)}
											text={t('create_wallet_message_13')}
											weight="medium"
											withBackground={true}
											backgroundColor={theme.primary_normal}
										/>
									</div>
								</div>
							</div>
						)
					}
				</>
			)}
			{showLoading && (
				<div style={styles.loadingcontainer}>
					<div style={{ marginBottom: "10px" }}>
						<BounceLoader color={"blue"} size={100} />
					</div>

					<CustomText weight="medium" style={{ ...styles.loadingtitle }}>
						{t('qss_load_process_screen_message_01')}
					</CustomText>

					<CustomText style={{ ...styles.loadingsubTitle1 }}>
						{t('qss_load_process_screen_message_02')}
					</CustomText>

					<CustomText style={{ ...styles.loadingsubTitle2 }}>
						{t('qss_load_process_screen_message_03')}
					</CustomText>
				</div>
			)}


		</div>
	)
}

export default QssSettingMnemonicPassword